import flyerOne from '../assets/img/campanaJovenes2024.JPG';
import flyerTwo from '../assets/img/campanaDamas2023.jpg';
import flyerThree from '../assets/img/campanaCaballeros2023.jpg';
import flyerFour from '../assets/img/campanaDeCaballeros2022.jpg';
import flyerFive from '../assets/img/campanaJovenes2022.jpg';
import flyerSix from '../assets/img/salidaIsrael.jpg';


export const FLYERS = [
    {
        id: 0,
        image: flyerOne,
        title: 'Campaña de Jovenes',
        description: 'Bienvenidos a nuestra Campaña de Jovenes.  Julio 11 y 12.  Unase a nosotros para adorar al Señor!'
    },
    {
        id: 1,
        image: flyerTwo,
        title: 'Campaña de Damas',
        description: 'Bienvenidos a nuestra Campaña de Damas.  Junio 1 y 2.  Unase a nosotros para adorar al Señor!'
    },
    {
        id: 2,
        image: flyerThree,
        title: 'Campaña de Caballeros',
        description: 'Bienvenidos a nuestra Campaña de Caballeros.  Unase a nosotros para adorar al Señor!'
    },
    {
        id: 3,
        image: flyerFour,
        title: 'Campaña de Caballeros 2022',
        description: 'Bienvenidos a nuestra Campaña de Caballeros.  Unase a nosotros para adorar al Señor!'
    },
    {
        id: 4,
        image: flyerFive,
        title: 'Campaña de Jovenes',
        description: 'Unase a nosotros para adorar al Señor!'
     },
     {
        id: 5,
        image: flyerSix,
        title: 'Salida a Israel!',
        description: 'Unase a nosotros para caminar donde nuestro Señor Jesucristo camino.'
     }      
]